import React from 'react';
import { Link } from 'react-router-dom';

const ScholarshipCard = ({ scholarship, status, isApplicationPeriodActive, hasApplied }) => {
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden">
      <div className="p-6">
        <h3 className="text-xl font-semibold text-gray-900 mb-2">{scholarship.title}</h3>
        
        <div className="mb-4">
          <p className="text-sm text-gray-600 mb-2">
            <strong>Eligibility:</strong> {scholarship.eligibility}
          </p>
          
          <div className="mt-2">
            <strong className="text-sm text-gray-600">Benefits:</strong>
            <ul className="list-disc list-inside text-sm text-gray-600 mt-1">
              {scholarship.benefits.map((benefit, index) => (
                <li key={index}>{benefit}</li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-2 text-sm text-gray-600">
          <p><strong>Application Period:</strong></p>
          <p>Start: {scholarship.startDate ? formatDate(scholarship.startDate) : 'N/A'}</p>
          <p>End: {scholarship.endDate ? formatDate(scholarship.endDate) : 'N/A'}</p>
          <p className="mt-2">
            <span className={`inline-block px-2 py-1 rounded-full text-xs font-semibold ${
              isApplicationPeriodActive
                ? 'bg-[rgb(130,88,18)] text-white'
                : status === 'upcoming' ? 'bg-yellow-100 text-yellow-800' : 'bg-red-100 text-red-800'
            }`}>
              {status.charAt(0).toUpperCase() + status.slice(1).replace('_', ' ')}
            </span>
          </p>
        </div>

        <div className="mt-4">
          <h3 className="text-lg font-semibold text-gray-700">Required Documents</h3>
          <ul className="list-disc list-inside text-gray-600 mt-1">
            {scholarship.requiredDocuments && scholarship.requiredDocuments.map((doc, index) => (
              <li key={index}>{doc}</li>
            ))}
          </ul>
        </div>

        <div className="mt-6">
          {isApplicationPeriodActive ? (
            hasApplied ? (
              <button
                disabled
                className="w-full inline-flex justify-center items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-gray-500 cursor-not-allowed transition-colors duration-300"
              >
                Applied
              </button>
            ) : (
              <Link
                to={`/scholarships/${scholarship.id}/apply`}
                className="w-full inline-flex justify-center items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-[rgb(130,88,18)] hover:bg-[rgb(110,75,15)] transition-colors duration-300"
              >
                Apply Now
              </Link>
            )
          ) : (
            <button
              disabled
              className="w-full inline-flex justify-center items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-gray-400 cursor-not-allowed transition-colors duration-300"
            >
              {status === 'upcoming' ? 'Coming Soon' : 'Applications Closed'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ScholarshipCard; 